// extracted by mini-css-extract-plugin
export default {"TeamsContainer":"Teams_TeamsContainer__Ciu7h"};